import moment from 'moment';
import { simpleDayOfMonth } from 'as-ui-kit/utils/time';

export const getRemainingTime = (locale, addDaysCount) => {
    const addDays = moment().add(addDaysCount, 'days').startOf('day');
    const today = new Date();
    const diff = moment.duration(addDays - today);
    return {
        date: simpleDayOfMonth(addDays.add(-1, 'days').toDate(), locale, true).split(' ').join('\u00A0'),
        days: diff.days(),
        hours: diff.hours(),
        minutes: diff.minutes()
    };
};